import { Alert, Box, List, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Repeat } from "lib/@components/repeat"
import Iconify from "minimals-template/components/Iconify"
import { ComponentProblemItem } from "./component-problem-item"

export function CannotApplyComponentDialog({ problems = [] }) {
    return (
        <DialogBox
            title={
                <Box display={"flex"} alignItems={"center"} gap={"20px"} data-cy="cannot-apply-component-title">
                    <Iconify icon={"material-symbols:warning"} />
                    <Typography variant="h5">Can&apos;t use this component</Typography>
                </Box>
            }
            value={true}
            okCaption={"Ok"}
        >
            <Box data-cy="cannot-apply-component-dialog">
                <Typography mt={2} data-cy="cannot-apply-component-message">
                    Update the component in the Component Library to fix the following, then use Find Similar again.
                </Typography>
                <Alert
                    severity="error"
                    icon={<Iconify icon={"material-symbols:cancel"} />}
                    data-cy="cannot-apply-component-alert"
                    sx={{
                        alignItems: "center",
                        "& .MuiAlert-icon": { display: "flex", alignItems: "center" },
                        mt: 2.5,
                    }}
                >
                    <List
                        data-cy="cannot-apply-component-list"
                        sx={{
                            listStyleType: "disc",
                            listStylePosition: "inside",
                            "& .MuiListItem-root": { display: "list-item", p: 0 },
                        }}
                    >
                        <Repeat list={problems} item={<ComponentProblemItem />} />
                    </List>
                </Alert>
            </Box>
        </DialogBox>
    )
}
